module.exports = __webpack_public_path__ + "static/media/scan_new.10acda25.svg";